<template>
  <div class="page-content">
    <div v-if="UserLoggedIn">
      <StatusComponent
        :timestamp-enabled="false"
        :data-view="true"
        :telemetry-search-standalone="true"
      />
    </div>
    <div
      v-if="!UserLoggedIn"
      class="content has-text-grey has-text-centered"
    >
      <p>
        <b-icon
          icon="emoticon-sad"
          size="is-large"
        />
      </p>
      <p>Please log in to access this page.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import StatusComponent from "@/components/Status.vue";
import Tools from "@/services/Tools.js";

export default {
  name: "Data",
  components: {
    StatusComponent
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["UserLoggedIn"]),
    ...mapState({
      userState: "user",
      dashboardState: "dashboardStates"
    })
  },
  methods: {
    hasPermission: Tools.hasPermission
  }
};
</script>

<style lang="scss">
@import "./../styles/pages.scss";
</style>